export default __webpack_public_path__ + "static/page-404-242a8b5c9896f42c9cc63978088e6301.svg";